<template>
  <div :class="{'option-switch':true, 'selected':shouldBeChecked}" @click="$emit('click');updateInput();">
    <label>
      <input class="option-switch-input" v-bind="$attrs"
             type="radio" :value="value" :checked="shouldBeChecked" @change="updateInput">

      <div class="item">
        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"></circle>
          <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"></path>
        </svg>
        <div class="title">{{label}}</div>
      </div>
    </label>
  </div>

</template>

<script>

export default {
  inheritAttrs: false,

  name: "VOptionSwitch",
  components: {
  },
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    value: {
      default: null
    },
    modelValue: {
      default: null
    },
    label: {
      type: String,
      required: true
    },
  },
  data: function() {
    return {};
  },
  computed: {
    shouldBeChecked() {
      return this.modelValue === this.value
    }
  },
  methods: {
    updateInput() {
      this.$emit('change', this.value)
    }
  }
}
</script>
<style lang="scss" scoped>
.option-switch {
  label {
    cursor: pointer;
  }
  input[type=radio] {
    display: none;
  }

  &.selected .item {

  }

}
.checkmark {
  display: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  stroke-width: 2;
  stroke: #fff;
  stroke-miterlimit: 10;
  box-shadow: inset 0 0 0 #7ac142;
  border: none;
  animation: fill 0.4s ease-in-out 0.4s forwards, scale 0.3s ease-in-out 0.9s both;
}

.option-switch.selected .checkmark {
  display: block;
  float: left;
  top: -10px;
  left: -10px;
  width: 20px;
  height: 20px;
  position: absolute;
  z-index: 50;
}

.checkmark__circle {
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  stroke-width: 2;
  stroke-miterlimit: 10;
  stroke: #7ac142;
  fill: none;
  animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}

.checkmark__check {
  transform-origin: 50% 50%;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%, 100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #7ac142;
  }
}

.option-switch.selected {
  border-color: #161617 !important;
  background: #5c5c5fbf !important;
  color: white;
}

.option-switch.disabled {
  cursor: not-allowed;
}

.option-switch {
  font-family: inherit;
  font-weight: 700;
  font-style: normal;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  position: relative;
  display: block;
  float: left;
  line-height: 1;
  cursor: pointer;
  padding: 9px 11px;
  margin: 3px 9px 7px 3px;
  font-size: 0.76471em;
  background-color: #fff;
  border: 1px solid #fff;
  border-color: #acabad;
  color: #221f27;
  border-radius: 3px;
}
</style>
